import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import useAuthStore from '@/stores/useAuthStore'
import { useToast } from '@/components/ui/use-toast'

const AuthCallbackPage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { login } = useAuthStore()
  const { toast } = useToast()

  useEffect(() => {
    const handleAuth = async () => {
      const hashParams = new URLSearchParams(location.hash.substring(1))
      const idToken = hashParams.get('id_token')

      if (idToken) {
        try {
          await login(idToken)
          toast({
            title: 'Login Successful',
            description: "Welcome! You've been successfully logged in.",
          })
          navigate('/history', { replace: true })
        } catch (error) {
          const errorMessage =
            error instanceof Error
              ? error.message
              : 'An unknown error occurred.'
          toast({
            variant: 'destructive',
            title: 'Login Failed',
            description: errorMessage,
          })
          navigate('/login', { replace: true })
        }
      } else {
        const error = hashParams.get('error')
        toast({
          variant: 'destructive',
          title: 'Login Failed',
          description:
            error || 'Could not retrieve Google authentication token.',
        })
        navigate('/login', { replace: true })
      }
    }

    handleAuth()
  }, [location, login, navigate, toast])

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-10 w-10 animate-spin text-primary" />
        <p className="text-muted-foreground">Authenticating with Google...</p>
      </div>
    </div>
  )
}

export default AuthCallbackPage
